<template>
  <div class="fill-height">
    <v-toolbar
      dark
      color="primary"
    >
      <v-toolbar-title class="pl-6">
        <span class="text-capitalize">Create {{ $route.params.object }}</span>
      </v-toolbar-title>
      <v-spacer />
      <v-btn
        text
        @click="handleClose"
      >
        <v-icon class="mr-4">
          mdi-keyboard-return
        </v-icon>
        Back to project
      </v-btn>
    </v-toolbar>
    <div style="overflow:auto;height:calc(100% - 64px);">
      <component
        :is="'create-'+$route.params.object"
        v-if="$route.params.object!=null"
        :id="$route.params.identifier"
        :name="$route.params.identifier"
        :project="{name : $route.params.project}"
        @create="handleCreate"
        @updateCloseConstraint="handleCloseConstraint"
      />
    </div>
  </div>
</template>
<script>
  import Query from './../Dashboard/Views/Projects/Dashboards/QueryBuilder'
  import Dataset from './../Dashboard/Views/Datastore/DatasetCreateUpdate.temp'
  import Function from './../Dashboard/Views/Functions/FunctionCreateUpdate'
  import Api from './../Dashboard/Views/Apis/ApiCreateUpdate'
  import Connector from './../Dashboard/Views/Integrations/IntegrationConfigCreate'
  import Trigger from './../Dashboard/Views/Trigger/TriggerNew'
  export default {
    components: {
      'create-trigger': Trigger,
      'create-integration': Connector,
      'create-api': Api,
      'create-function': Function,
      'create-dataset': Dataset,
      'create-query': Query,
    },
    data () {
      return {
        closeConstraint: null,
      }
    },
    methods: {
      handleCloseConstraint (e) {
        this.closeConstraint = e
      },
      handleCreate (data) {
        let self = this
        this.$router.push((self.$route.params.project ? `/projects/${self.$route.params.project}/` : `/library/`) + `view/${this.$route.params.object}/${data[_.find(this.$appConfig.objects, { type: this.$route.params.object }).identifier]}`)
      },
      handleClose () {
        let self = this

        if (this.closeConstraint == null) {
          self.$router.push(self.$route.params.project ? `/projects/${self.$route.params.project}` : `/library/`)
        } else {
          this.$store.commit('confirm', {
            message: self.closeConstraint,
            title: 'Warning',
            color: 'orange',
            onCancel: () => {},
            onConfirm: () => {
              self.dialog = false
              _.delay(() => {
                self.$router.push(self.$route.params.project ? `/projects/${self.$route.params.project}` : `/library/`)
              }, 300)
            },
          })
        }
      },
    },
  }
</script>
